import SelectFilterModal from './SelectFilterModal'
import usePowiatFilterModal from '../hooks/usePowiatFilterModal'

export default function PowiatFilterModal({
	isOpen,
	onClose,
	selectedPowiatId,
	idWojewodztwo = null,
	onApply,
	title = 'Filtruj po powiecie',
	description = 'Wybierz powiat, aby zawezic liste placowek.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	const state = usePowiatFilterModal(isOpen, selectedPowiatId, idWojewodztwo)
	return (
		<SelectFilterModal
			isOpen={isOpen}
			onClose={onClose}
			onApply={onApply}
			title={title}
			description={description}
			placeholder="Szukaj powiatu po nazwie..."
			emptyMessage="Nie znaleziono powiatow"
			applyLabel={applyLabel}
			clearLabel={clearLabel}
			{...state}
		/>
	)
}
